import * as React from "react";
import * as ReactDOM from "react-dom";
import * as $ from "jquery";

import ConnectedPeopleComp from "./ConnectedPeopleComp";
import ToggleBtn from "../lib/components/ToggleBtn";
import {Select, ISelectItem} from "../lib/components/Select";
import { ComboBox, IComboBoxValues } from "../lib/components/ComboBox";
import Modal from "../lib/components/Modal";
import {EditItemCompEvents} from "./EditItemCompEvents";
import {ProfileFormFields, IProfileFormFieldsProps} from "./ProfileFormFields";


import {IUser, IProileComp, IUserWithDefaultConnection, IEditItemCompProps, IConnnectedPeople, IEditItemCompState} from "../../interfaces/layout/blocks/IUser";

declare var window:any;
window.currentModal = null;
export class EditItemCompMain extends EditItemCompEvents{
    constructor(props: IEditItemCompProps) {
        super(props);
    }

    render() {
        var showProfileFormFields = this.state.showProfielFromFields;
        if ( document.getElementById("showMoreBtnTest") !== null ) {
            showProfileFormFields = true;
        }
        // var fatherClass:string = 'box father';
        // var motherClass:string = 'box mother';
        // var coupleClass:string = '';
        // var childrenClass:string = '';
		var data:IUser = this.state.data;
		var ProfileFormFieldsData:IProfileFormFieldsProps = this.state.ProfileFormFieldsData;
        var typeText:string = '';
        switch( data.type ){
            case 'father':
                // fatherClass += ' active';
                typeText = 'apa';
            break;
            case 'mother':
                // motherClass += ' active';
                typeText = 'anya';
            break;
            case 'couple':
                // coupleClass = 'active';
                typeText = 'pár';
            break;
            case 'children':
                // childrenClass = 'active';
                typeText = 'gyermek';
            break;
        }
		var registrationMode:boolean = this.props.registrationMode;
        var placeholder:string = 'Anyja neve';
        if ( this.state.motherId !== null ) {
            placeholder = 'Apja neve';
        }

        var birthDate:Array<string> = ['','',''];
        var temp:Array<string> = data.birthDate.split('.');
        for (let i = 0; i < 3; i++) {
            if ( temp[i] !== undefined ) {
                birthDate[i] = temp[i];
            }
        }
        var deathBoxStyle:any = { };
        var deathDate:Array<string> = ['','',''];
        temp = data.deathDate.split('.');
        for (let i = 0; i < 3; i++) {
            if ( temp[i] !== undefined ) {
                deathDate[i] = temp[i];
            }
        }

        if ( this.state.showDeathbox === false ) {
            deathBoxStyle = {
                display: "none"
            };
        }else{
            deathBoxStyle = {};
        }
        var fatherName:string = '';
        var fatherDate:string = '()';
        if ( this.state.fatherName !== null ) {
            temp = this.state.fatherName.split(' (');
            fatherName = temp[0];
            fatherDate = '('+ temp[1].replace(/-/g,'.');
			if ( fatherDate === '(0000.00.00)') {
				fatherDate = '()';
			}
            // fatherClass += ' founded';
        }
        var motherName:string = '';
        var mohterDate:string = '()';

        if ( this.state.motherName !== null ) {
            temp = this.state.motherName.split(' (');
            motherName = temp[0];
            mohterDate = '('+ temp[1].replace(/-/g,'.');
			if ( mohterDate === '(0000.00.00)') {
				mohterDate = '()';
			}
            // motherClass += ' founded';
        }
		if ( this.id === 0 ) {
			// motherClass += ' noclick';
			// fatherClass += ' noclick';
		}
		var profileUrl:string = '/profilok/'+this.id;
        /*
        <div className="debug" style={{ display: 'block'}}>
            <div>
                id: { this.id }<br />
                currentId/creatorId: { this.currentId }<br />
                <div className="row" style={ this.id > 0? {} : { display: 'none'}  }>
                    <div className="box">
                    </div>
                    <div className="box right">
                        <br />
                        <button type="button" name="send" className="btn danger small" onClick={ e => this.removeClickHandler(e) }><i className="ion-trash-a"></i></button>
                        <br />
                    </div>
                </div>
            </div>
        </div>
        */
        var title:string = '';
        if ( this.id === 0 ) {
            if ( typeText !== '' ) {
                title = typeText + ' - ';
            }
            title += 'Új családtag felvitele';
            $('.item_edit_modal').addClass('small');
        }else{
            $('.item_edit_modal').removeClass('small');
            title = this.state.data.lastName + ' ' + this.state.data.firstName;
        }
        return (
            <div id="item_editor_cont">
                { this.props.profileMode === false && this.props.registrationMode === false?<h1>
                    { title }
                </h1>:'' }


                { this.id > 0?<a href={ profileUrl } className="btn profileBtn">TOVÁBB A PROFILRA</a>:'' }

                <form className="form" action="/" method="post" onSubmit={ e => this.submitHandler(e) }>
                    <div className="row col2">
                        <div className="box">
                            { this.props.profileMode === false && this.props.registrationMode === false ?<div>
                                <legend>Profilkép</legend>
                                <div className="profile_uploader_box connectedPeopleComp" id="editor_item_comp_image"></div>
                            </div>
                            :'' }<div className="profile_uploader_box connectedPeopleComp" id="editor_item_comp_image"></div>

                            <legend>Személyes adatok</legend>
                            <input type="hidden" name="type" value={ data.type } />

                            { registrationMode === false && this.id === 0 ? <ComboBox currentValue={ data.lastName } currentLabel={ data.lastName } changed={ (value, label) => this.allUserChangeHandler(value, label) } source={
                                this.state.allUser.source
                            } placeholder="Vezetéknév" key="allUser" /> : <input type="text" name="lastName" value={ data.lastName } placeholder="Vezetéknév" required={true} onChange={ e => this.fieldChangeHandler(e) } /> }



                            <div className="row">
                                <div className="box">
                                    <input type="text" name="firstName" value={ data.firstName } placeholder="Keresztnév" required={true} onChange={ e => this.fieldChangeHandler(e) } />
                                </div>
                                <div className="box right">
                                    <ToggleBtn current_value={ data.sex } values={ [{ name: 'Férfi', value: 'male' }, { name: 'Nő', value: 'female' }]} changed={ (new_value) => this.sexChangeHandler(new_value) }/>
                                </div>
                            </div>

                            { this.showOtherParentCombobox()?<ComboBox currentValue={ this.state.otherParent.currentValue } currentLabel={ this.state.otherParent.currentLabel } changed={ (value, label) => this.otherParentChangeHandler(value, label) } source={
                                this.state.otherParent.source
                            } placeholder={placeholder} key="otherParent" />:''}

                            <input type="email" name="email" value={ data.email } placeholder="E-mail cím" onChange={ e => this.emailChangeHandler(e) } />

                            <div className="row">
                                <div className="box">
                                    <input type="password" name="password" value={ data.password } placeholder="Jelszó" onChange={ e => this.passwordChangeHandler(e) } />
                                </div>
                                <div className="box p5">
                                    <input type="password" name="passwordm" value={ this.state.passwordm } placeholder="Jelszó ismétlés" onChange={ e => this.passwordMChangeHandler(e) } />
                                </div>
                            </div>

                            <div className="row col3">
                                <input type="hidden" name="birthDate" value={ data.birthDate } placeholder="Születési dátum" onChange={ e => this.fieldChangeHandler(e) } />
                                <div className="box">
                                    <input type="text" value={ birthDate[0] } data-index="0" placeholder="Születési év" onChange={ e => this.birthDateChangeHandler(e) } />
                                </div>
                                <div className="box p5">
                                    <Select enableNewItem={false} multifield_mode={false} items={ this.getMonth(parseInt(birthDate[1]), 'Születési hó') } key= { "getmonth" +  Math.random() } itemChangeHandler={ id => this.birthDateChangeHandler(undefined, 1, id) }/>
                                </div>
                                <div className="box p5">
                                    <Select enableNewItem={false} multifield_mode={false} items={ this.getDays(parseInt(birthDate[2]), 'Születési nap') } key= { "getday" +  Math.random() } itemChangeHandler={ id => this.birthDateChangeHandler(undefined, 2, id) }/>
                                </div>
                            </div>

                            <input type="text" name="birthName" value={ data.birthName } placeholder="Születési név" onChange={ e => this.fieldChangeHandler(e) } />

                            <div className="row">
                                <div className="box">
                                    <ComboBox currentValue={ data.birthPlaceCountry } currentLabel={ data.birthPlaceCountry } changed={ (value, label, coords) => this.changeBirthBirthPlaceCountry(value, label, coords) } google={true} placeholder="Születési ország" key="birthPlaceCountry" />
                                </div>
                                <div className="box p5">
                                    <ComboBox currentValue={ data.birthPlaceCity } currentLabel={ data.birthPlaceCity } changed={ (value, label, coords) => this.changeBirthPlaceCity(value, label, coords) } google={true} placeholder="Születési város" googleCityMode={true} googleFromCountry={ data.birthPlaceCountry } key="birthPlaceCity" />
                                </div>
                            </div>

                            <ComboBox currentValue={ data.city } currentLabel={ data.city } changed={ (value, label, coords) => this.changeCity(value, label, coords) } google={true} placeholder="Lakcím város" googleCityMode={true} />


                            <div style={ deathBoxStyle }>
                                <div className="row col3">
                                    <input type="hidden" name="deathDate" value={ data.deathDate } placeholder="Halál dátum" onChange={ e => this.fieldChangeHandler(e) } />
                                    <div className="box">
                                        <input type="text" value={ deathDate[0] } data-index="0" placeholder="Halál éve" onChange={ e => this.deathDateChangeHandler(e) } />
                                    </div>
                                    <div className="box p5">
                                        <Select enableNewItem={false} multifield_mode={false} items={ this.getMonth(parseInt(deathDate[1]), 'Halál hónapja') } key={ "getmonth_d" + Math.random() } itemChangeHandler={ id => this.deathDateChangeHandler(undefined, 1, id) }/>
                                    </div>
                                    <div className="box p5">
                                        <Select enableNewItem={false} multifield_mode={false} items={ this.getDays(parseInt(deathDate[2]), 'Halál napja') } key={ "getday_d" + Math.random() } itemChangeHandler={ id => this.deathDateChangeHandler(undefined, 2, id) }/>
                                    </div>
                                </div>
                                <div>
                                    <input type="text" name="elhalálozás helye" placeholder="Elhalálozás helye" />
                                </div>
                            </div>



                            { registrationMode === false && showProfileFormFields === true?<ProfileFormFields
                                itemPlaces    = { ProfileFormFieldsData.itemPlaces }
                                itemSchools   = { ProfileFormFieldsData.itemSchools }
                                itemJobs      = { ProfileFormFieldsData.itemJobs }
                                itemHonors    = { ProfileFormFieldsData.itemHonors }
                                itemArmy      = { ProfileFormFieldsData.itemArmy }
                                itemLanguages = { ProfileFormFieldsData.itemLanguages }
                                itemHobbies   = { ProfileFormFieldsData.itemHobbies }
                                nameDayMonth  = { ProfileFormFieldsData.nameDayMonth }
                                nameDayDay    = { ProfileFormFieldsData.nameDayDay }
                                note          = { ProfileFormFieldsData.note }
                                religion      = { ProfileFormFieldsData.religion }
                                changeHandler = { props => this.proileFormFieldsChangeHandler(props) }
                                viewMode={false}
                                />:<a title="Profil adatok" className="profile_detail_btn" style={ registrationMode === true? { display: 'none'}:{}} onClick={ e => this.toggleProfileFormFieldsHandler(e) }><span className="add_new_icon"></span> <span className="text">További adatok megadása</span></a>}
                            <br />
                            <br />

                            <ul className="alert alert-danger">
                                {this.state.errors.map((item, key:number) => {
                                    return (<li key={key}>{ item }</li>);
                                })}
                            </ul>
                            <ul className="alert alert-success">
                                {this.state.success.map((item, key:number) => {
                                    return (<li key={key}>{ item }</li>);
                                })}
                            </ul>
                        </div>
                        <div className="box">
                            {  registrationMode === true || this.props.profileMode === true || this.id === 0 ? '': <div>
                                <legend>Családtagok</legend>
                                <div className="brbox">
                                    <h2>
                                     <a onClick = { e => this.changeTypeHandler(e, 'father') }>
                                        { fatherName === ''?<span>
                                            <span className="add_new_icon"></span> <span className="text">APA MEGADÁSA</span>
                                        </span>:fatherName }
                                        { fatherDate !== '()' ? <span> {fatherDate}</span> : '' }
                                    </a>
                                    </h2>
                                </div>
                                <div className="brbox">
                                    <h2>
                                        <a onClick = { e => this.changeTypeHandler(e, 'mother') }>
                                            { motherName === ''?<span>
                                                <span className="add_new_icon"></span> <span className="text">ANYA MEGADÁSA</span>
                                            </span>:motherName }
                                            { mohterDate !== '()' ? <span> {mohterDate}</span> : '' }
                                        </a>
                                    </h2>
                                </div>
                                <div className="brbox">
                                    <ConnectedPeopleComp label="PÁR MEGADÁSA" type="couples" activeClass={''} enabledAddNew={ this.id > 0} connnectedPeople={ this.state.connnectedPeople.couples } changeTypeHandler={ e => this.changeTypeHandler(e, 'couple') } getData={ (id) => this.getData(id) } />
                                </div>
                                <div className="brbox">
                                    <ConnectedPeopleComp label="GYERMEK MEGADÁSA" type="children" activeClass={''} enabledAddNew={ this.id > 0} connnectedPeople={ this.state.connnectedPeople.childrens } changeTypeHandler={ e => this.changeTypeHandler(e, 'children') } getData={ (id) => this.getData(id) } />
                                </div>
                            </div>
                            }
                        </div>
                    </div>


                    <div className="button_row">
                        {  registrationMode === true ? '': <button type="button" className="btn show_death_box_btn" onClick={ e => this.toggleDeathBoxChangeHandler(e) } >RIP</button> }
                        <button type="button" className="btn close" onClick={ e => this.closeClickHandler(e) }>Mégsem</button>
                        <button type="submit" name="send" className="btn red">Mentés</button>
                    </div>
                </form>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/EditItemCompMain.tsx